export const findPathIndex = (path: string, navigation: string[]) => {
  return navigation.indexOf(path);
};
